/* ============================================================
   Cloud Store · Editorial JS (Vague 4)
   Blog tags filter, article share buttons, product card insert,
   contact FAQ.
   ============================================================ */
(function () {
  if (window.__csEditorialInit) return;
  window.__csEditorialInit = true;

  // ---------- Article share buttons ----------
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cs-share]');
    if (!btn) return;
    const action = btn.dataset.csShare;
    if (action === 'copy') {
      e.preventDefault();
      navigator.clipboard.writeText(window.location.href).then(() => {
        showToast('Lien copié 🔗');
      }).catch(() => {
        showToast('Impossible de copier', true);
      });
    }
  });

  // ---------- Article product-card insertion ----------
  function insertProductCard() {
    const card = document.querySelector('[data-cs-article-product]');
    const body = document.querySelector('[data-cs-article-body]');
    if (!card || !body) return;
    const paragraphs = body.querySelectorAll('p');
    if (paragraphs.length < 4) return; // too short, leave at end (Liquid fallback)
    const targetIdx = Math.floor(paragraphs.length * 0.65);
    const target = paragraphs[targetIdx];
    if (target && target.parentNode) {
      target.parentNode.insertBefore(card, target.nextSibling);
      card.style.display = '';
    }
  }

  // ---------- Contact "open Mimi" trigger ----------
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cs-contact-mimi]');
    if (!btn) return;
    e.preventDefault();
    const mimiTrigger = document.querySelector('[data-cs-mimi-trigger]');
    if (mimiTrigger) mimiTrigger.click();
  });

  // ---------- Toast helper ----------
  function showToast(msg, isError = false) {
    if (window.__csShowToast) {
      window.__csShowToast(msg, isError);
      return;
    }
    const t = document.createElement('div');
    t.className = 'cs-toast' + (isError ? ' warning' : '');
    t.textContent = msg;
    Object.assign(t.style, {
      position: 'fixed', bottom: '24px', left: '50%',
      transform: 'translateX(-50%)',
      background: isError ? '#c44a4a' : 'var(--cs-bordeaux, #5E2F4D)',
      color: 'white', padding: '14px 20px', borderRadius: '16px',
      fontSize: '14px', zIndex: 300,
      boxShadow: '0 8px 24px rgba(33,29,44,0.2)',
    });
    document.body.appendChild(t);
    setTimeout(() => t.remove(), 3500);
  }

  // ---------- Init on load ----------
  document.addEventListener('DOMContentLoaded', () => {
    insertProductCard();
  });
})();
